export default __webpack_public_path__ + "static/media/brow-chakra.34ade3dd.png";